import { NavLink } from "react-router-dom";

function AdminHeaderLinks() {
  return (
    <div className="admin-subheader-links">
      <ul>
        <li>
          <NavLink className={({ isActive }) => isActive ? "active" : "" } to="/settings/sso-setup">
            SSO Setup
          </NavLink>
        </li>
        <li>
          <NavLink className={({ isActive }) => isActive ? "active" : "" } to="/settings/announcements">
            Announcements
          </NavLink>
        </li>
        <li>
          <NavLink className={({ isActive }) => isActive ? "active" : "" } to="/settings/web-tracker">
            Web Tracker
          </NavLink>
        </li>
        <li>
          <NavLink className={({ isActive }) => isActive ? "active" : "" } to="/settings/compliance-settings">
            Compliance Settings
          </NavLink>
        </li>
        <li>
          <NavLink className={({ isActive }) => isActive ? "active" : "" } to="/settings/project-settings">
            Project Settings
          </NavLink>
        </li>
      </ul>
    </div>
  );
}

export default AdminHeaderLinks;